import { Component, Inject, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UploadService } from '../service/upload.service';
import { CommentsService } from '../service/comments.service';
import { SettingsService } from '../service/settings.service';
import { FileHandle } from '../directive/drag-and-drop.directive';
import { ActivatedRoute } from '@angular/router';
import { deepCopy, makeid, removeUndefinedValuesFromObject } from 'na-lib';
import { environment } from 'src/environments/environment';
import { AdvancedExperiencesService } from '../service/advanced-experiences.service';
import { TranslateService } from '@ngx-translate/core';
import { httpsCallable, Functions } from '@angular/fire/functions';
import { FormArray, FormControl } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';

// --- Allowed AppClip languages --
export const LANGUAGE_LABELS_: Record<'en' | 'de' | 'es', Record<string, string>> = {
    en: {
      AR: 'Arabic',
      CA: 'Catalan',
      CS: 'Czech',
      DA: 'Danish',
      DE: 'German',
      EL: 'Greek',
      EN: 'English',
      ES: 'Spanish',
      FI: 'Finnish',
      FR: 'French',
      HE: 'Hebrew',
      HI: 'Hindi',
      HR: 'Croatian',
      HU: 'Hungarian',
      ID: 'Indonesian',
      IT: 'Italian',
      JA: 'Japanese',
      termKO: 'Korean',
      MS: 'Malay',
      NL: 'Dutch',
      NO: 'Norwegian',
      PL: 'Polish',
      PT: 'Portuguese',
      RO: 'Romanian',
      RU: 'Russian',
      SK: 'Slovakian',
      SV: 'Swedish',
      TH: 'Thai',
      TR: 'Turkish',
      UK: 'Ukrainian',
      VI: 'Vietnamese',
      ZH: 'Chinese',
    },
    de: {
      AR: 'Arabisch',
      CA: 'Katalanisch',
      CS: 'Tschechisch',
      DA: 'Dänisch',
      DE: 'Deutsch',
      EL: 'Griechisch',
      EN: 'Englisch',
      ES: 'Spanisch',
      FI: 'Finnisch',
      FR: 'Französisch',
      HE: 'Hebräisch',
      HI: 'Hindi',
      HR: 'Kroatisch',
      HU: 'Ungarisch',
      ID: 'Indonesisch',
      IT: 'Italienisch',
      JA: 'Japanisch',
      termKO: 'Koreanisch',
      MS: 'Malaiisch',
      NL: 'Niederländisch',
      NO: 'Norwegisch',
      PL: 'Polnisch',
      PT: 'Portugiesisch',
      RO: 'Rumänisch',
      RU: 'Russisch',
      SK: 'Slowakisch',
      SV: 'Schwedisch',
      TH: 'Thailändisch',
      TR: 'Türkisch',
      UK: 'Ukrainisch',
      VI: 'Vietnamesisch',
      ZH: 'Chinesisch',
    },
    es: {
      AR: 'Árabe',
      CA: 'Catalán',
      CS: 'Checo',
      DA: 'Danés',
      DE: 'Alemán',
      EL: 'Griego',
      EN: 'Inglés',
      ES: 'Español',
      FI: 'Finés',
      FR: 'Francés',
      HE: 'Hebreo',
      HI: 'Hindi',
      HR: 'Croata',
      HU: 'Húngaro',
      ID: 'Indonesio',
      IT: 'Italiano',
      JA: 'Japonés',
      termKO: 'Coreano',
      MS: 'Malayo',
      NL: 'Neerlandés',
      NO: 'Noruego',
      PL: 'Polaco',
      PT: 'Portugués',
      RO: 'Rumano',
      RU: 'Ruso',
      SK: 'Eslovaco',
      SV: 'Sueco',
      TH: 'Tailandés',
      TR: 'Turco',
      UK: 'Ucraniano',
      VI: 'Vietnamita',
      ZH: 'Chino',
    },
  };

export function urlPrefixValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
      const validUrlPattern = /^[a-zA-Z0-9-_]+$/;
      const valid = validUrlPattern.test(control.value);
      return valid ? null : { invalidUrlPrefix: true };
  };
}

@Component({
    selector: 'app-cover-image-dialog-dialog',
    templateUrl: './cover-image-dialog.component.html',
    styleUrls: ['./cover-image-dialog.component.css'],
    standalone: false
})

export class CoverImageDialogComponent {
  isUpdate = false;
  existingId: string | null = null;
  saving = false
  advancedForm!:FormGroup
  files: FileHandle[] = []
  drop=false
  url:any
  allImages:any=[]
  coverImage:any
  environment = environment
  newImage:any=[]
  changes=false
  advancedData:any
  routerUrl:any
  languagesList:any
  contentTypeId:any
  accountLanguages:any
  contentType:any
  nfcURLPrefix:any
  contentForm!:FormGroup
  advancedExperienceId:any
  coverImageData:any
  oldCoverImage:any
  contenTypeForm!:FormGroup
  contextId: any
  newCover=false
  selectedFile: File | null = null;
  previewSrc: string | null = null;
  remainingLanguagesList: Array<{ key: string; label: string }> = [];
  idToShow:any
  prefix = false
  existingUrlPrefixes:any=[]
  public isUrlPrefixValid = true;
  existingCoverImages:any
  alreadyPrefix=false
  // private readonly functions: Functions;
  private destroy$ = new Subject<void>();

  constructor(public dialogRef: MatDialogRef<CoverImageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private uploadService: UploadService,
    private cdRef: ChangeDetectorRef,
    private commentService: CommentsService,
    private settingsService: SettingsService,
    private router: ActivatedRoute,
    private functions: Functions,
    private advancedService:AdvancedExperiencesService,
    private translateService:TranslateService,
    private translate:TranslateService,
  ){
    // const functions = getFunctions(getApp(), 'europe-west1');
    // this.functions = functions
    dialogRef.disableClose = true;
    this.routerUrl=this.router.url
    this.idToShow=this.routerUrl.value[this.routerUrl.value.length-1].path 
    const currentLang = this.translate.currentLang() || 'en';
    this.languagesList = LANGUAGE_LABELS_[currentLang as 'en' | 'de' | 'es'] || LANGUAGE_LABELS_.en;

  }

  trackByKey = (_: number, item: { key: string }) => item.key;

  get translations(): FormArray {
    return this.advancedForm.get('translations') as FormArray;
  }

  get previewTitle(): string {
    return (
      this.advancedForm?.get('title')?.value ??
      this.coverImage?.title ??
      'Narravero'
    );
  }

  get previewSubtitle(): string {
    return (
      this.advancedForm?.get('subtitle')?.value ??
      this.coverImage?.subtitle ??
      'Touch Point'
    );
  }

  private recomputeRemainingLanguages(): void {
    const used = this.translations.controls.map(c => c.get('lang')?.value);
    const defaultLang = this.advancedForm?.get('defaultLanguage')?.value;

    this.remainingLanguagesList = Object.entries(this.languagesList)
      .filter(([key]) =>
        !used.includes(key) && key !== defaultLang
      )
      .map(([key, label]) => ({ key, label: label as string }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }


  private buildTranslationGroup(lang: string): FormGroup {
    return this.fb.group({
      lang: new FormControl(lang, Validators.required),
      title: new FormControl('', [Validators.required, Validators.maxLength(30)]),
      subtitle: new FormControl('', [Validators.required, Validators.maxLength(56)]),
    });
  }

  addTranslation(langKey: string) {
    if (!langKey) return;
    if (this.translations.controls.some(c => c.get('lang')?.value === langKey)) return;
    this.translations.push(this.buildTranslationGroup(langKey));
    this.recomputeRemainingLanguages();
  }

  removeTranslation(i: number) {
    this.translations.removeAt(i);
    this.recomputeRemainingLanguages();
  }

  ngOnInit():void{
    //this.advancedData = this.data.values
    this.advancedData = this.data

    const urlPrefix = this.data?.contentType?.nfcURLPrefix ? this.data?.contentType?.nfcURLPrefix : makeid(6)
    this.isUrlPrefixValid = this.validateUrlPrefix(urlPrefix);

    this.advancedForm = this.fb.group({
      contextId:[ , Validators.required],
      urlPrefix: [urlPrefix, [Validators.required,Validators.maxLength(15), urlPrefixValidator()]],
      defaultLanguage:[,Validators.required],
      title:[, [Validators.required, Validators.maxLength(30)]],
      subtitle:[, [Validators.required, Validators.maxLength(56)]],
      appStoreId:[],
      appStoreImageURL:[],
      url:[,Validators.required],
      contentTypeId: [, Validators.required],
      translations: this.fb.array([])
    })

    this.recomputeRemainingLanguages();

    this.translations.valueChanges.subscribe(() => {
      this.recomputeRemainingLanguages();
    });

    this.advancedForm.get('defaultLanguage')?.valueChanges.subscribe(() => {
      this.recomputeRemainingLanguages();
    });

    const {contextId, contentTypeId} = this.advancedData

    this.advancedForm.patchValue({
      contextId :  contextId ? contextId : this.settingsService.contextId$,
      contentTypeId: contentTypeId ? contentTypeId : this.idToShow
    })

    this.advancedForm.get('urlPrefix')?.valueChanges.subscribe(value => {
      this.isUrlPrefixValid = this.validateUrlPrefix(value);

      if (value) {
        this.prefix = true
        const allprefix = environment.tagHostName + value;
        // Check for existing prefixes
        if (this.existingUrlPrefixes) {
          const isCurrentExperiencePrefix = this.isUpdate && value === this.coverImage?.urlPrefix;
          this.alreadyPrefix = this.existingUrlPrefixes.includes(allprefix) && !isCurrentExperiencePrefix;
          if(this.alreadyPrefix){
            const urlPrefix = makeid(6)
            this.advancedForm.patchValue({urlPrefix})
          }
        }
      } else {// Reset the alreadyPrefix check if input is empty
        this.alreadyPrefix = false;
      }

      this.cdRef.detectChanges();
    });


    if(this.advancedForm.value.urlPrefix){
      this.prefix = true
    }

    if(this.alreadyPrefix && !this.isUpdate){
      this.commentService.addSnackBar.emit('this urlPrefix already exists')
    }

    if(this.advancedService.existingCoverImages.value?.length!=0){
      this.existingCoverImages = this.advancedService.existingCoverImages.value
      this.existingUrlPrefixes = this.advancedService.existingUrlPrefixes.value
    }else{
      this.advancedService.getActualUrlPrefixes(false)
    }

    this.advancedService.existingCoverImages.subscribe( value => { this.existingCoverImages = value } )
    this.advancedService.existingUrlPrefixes.subscribe( value => { this.existingUrlPrefixes = value } )

    if(this.data['contentType']){
      this.contentType = deepCopy(this.data['contentType'])
      //this.initializeContentTypeForm() NOT USED
      if(this.contentType.nfcURLPrefix){
        this.nfcURLPrefix = this.contentType.nfcURLPrefix

        this.getCoverImagesOfThisNFC()
      }
      else{
        if(this.contentType.advancedExperienceId){
          this.advancedExperienceId = this.contentType.advancedExperienceId
          this.getCoverImagesWithId(this.advancedExperienceId)
        }
      }
    }

    if(this.data['contentTypeId']){
      this.contentTypeId = this.data['contentTypeId']
    }

    if(this.data['contextId']){
      this.contextId = this.data['contextId']
    }
    this.accountLanguages = this.settingsService.languagesContexts$

  }

  private hydrateFormFromCover(cover: any) {
    if (!cover || !this.advancedForm) return;

    const defaultLang = cover.defaultLanguage || 'EN';

    this.advancedForm.patchValue({
      urlPrefix: cover.urlPrefix || this.advancedForm.value.urlPrefix,
      defaultLanguage: defaultLang,
      title: cover.title || '',
      subtitle: cover.subtitle || '',
      url: cover.imageUrl || ''
    });

    const fa = this.translations;
    while (fa.length) {
      fa.removeAt(0);
    }

    const translations = cover.translations || {};
    Object.keys(translations).forEach(lang => {
      const t = translations[lang] || {};
      fa.push(this.fb.group({
        lang: new FormControl(lang, Validators.required),
        title: new FormControl(t.title || '', [Validators.required, Validators.maxLength(30)]),
        subtitle: new FormControl(t.subtitle || '', [Validators.required, Validators.maxLength(56)]),
      }));
    });

    this.recomputeRemainingLanguages();
    this.cdRef.detectChanges();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  // --------------- Image selection (NO upload yet) ---------------
onFileChange(event: any) {
  if (!event.target.files || !event.target.files[0]) return;
  const file: File = event.target.files[0];

  const typeOk = ['image/jpeg', 'image/png', 'image/jpg'].includes(file.type);
  if (!typeOk) {
    const m = this.translateService.instant("SnackBarConstants.IMG_TYPE");
    this.commentService.addSnackBar.emit(m);
    return;
  }

  this.selectedFile = file;
  const reader = new FileReader();
  reader.readAsDataURL(file);

  reader.onload = async (e: any) => {
    const dataUrl = e.target?.result as string;
    if (!dataUrl) return;

    const valid = await this.validateImageDimensions(dataUrl);
    if (!valid) {
      this.handleInvalidDimensions();
      return;
    }

    this.previewSrc = dataUrl;
    this.url = dataUrl;
    this.changes = true;
    this.advancedForm.patchValue({ url: dataUrl });

    this.advancedForm.controls['urlPrefix'].disable();

  };
}


  validateUrlPrefix(value: string): boolean {
    const pattern = /^[a-zA-Z0-9-_]+$/;
    return pattern.test(value);
  }

  async getCoverImagesOfThisNFC() {
    try {
      const cover = await this.advancedService.getCoverImagesWithNFCPrefix(this.nfcURLPrefix);
      this.coverImage = cover || null;

      if (this.coverImage) {
        this.isUpdate = true;
        this.existingId = this.coverImage.id;
        this.hydrateFormFromCover(this.coverImage);
        // also set previewSrc from existing image if you want:
        if (!this.previewSrc && this.coverImage.imageUrl) {
          this.previewSrc = this.coverImage.imageUrl;
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  getCoverImagesOfThisAppStoreId(appStoreId){
    try{
      this.commentService.progressSpin.emit(true)

      this.coverImage = this.advancedService.getCoverImagesWithAppStoreId(appStoreId)
      
      if(this.coverImage ){
        if(this.coverImage.urlPrefix){
          this.nfcURLPrefix = this.coverImage.urlPrefix
          this.advancedExperienceId = this.coverImage.id
          this.contentForm.patchValue({nfcURLPrefix: this.nfcURLPrefix})
          this.contentForm.patchValue({advancedExperienceId: this.advancedExperienceId})
        }
      }

      this.commentService.progressSpin.emit(false)
      
    }catch(error){
      console.log(error)
      this.commentService.progressSpin.emit(false)

    }
  }

  getCoverImagesWithId(id){
    try{
      this.existingId = id;
      this.advancedService.observeAdvancedExperiencesIdFirestore(id).pipe(takeUntil(this.destroy$)).subscribe( value => {
        
        if(value){
          this.coverImage = {}
          this.coverImage = { id, ...value }
          if(this.coverImage){
            this.isUpdate = true;
            this.existingId = this.coverImage.id;
            this.hydrateFormFromCover(this.coverImage);
          }
        }else{
          this.commentService.addSnackBar.emit("cover image not founded")
        }
      })
      
    }catch(error){
      console.log(error)
    }
  }

  readonly REQUIRED_WIDTH = 1800;
  readonly REQUIRED_HEIGHT = 1200;

  private async validateImageDimensions(dataUrl: string): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      const img = new Image();
      img.onload = () => {
        const ok = img.width === this.REQUIRED_WIDTH && img.height === this.REQUIRED_HEIGHT;
        resolve(ok);
      };
      img.onerror = () => resolve(false);
      img.src = dataUrl;
    });
  }

  private handleInvalidDimensions(): void {
    this.selectedFile = null;
    this.newImage = null;
    this.previewSrc = null;
    this.url = null;

    if (this.advancedForm) {
      this.advancedForm.patchValue({ url: null });
      this.advancedForm.controls['urlPrefix']?.enable();
    }
    const msg =
      this.translateService.instant('SnackBarConstants.IMG_SIZE') ||
      'Image must be exactly 1800 × 1200 pixels.';
    this.commentService.addSnackBar.emit(msg);
  }

  private cacheBustedUrl(url: string): string {
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}v=${Date.now()}`;
  }
async filesDropped(files: FileHandle[]): Promise<void> {
  if (!files || !files.length) return;

  this.files = files;
  const fileToUpload = files[0].file;
  this.newImage = fileToUpload;
  this.selectedFile = fileToUpload;

  const type = this.newImage.type;
  const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
  if (!allowedTypes.includes(type)) {
    const message = this.translateService.instant("SnackBarConstants.IMG_TYPE");
    this.commentService.addSnackBar.emit(message);
    return;
  }

  const reader = new FileReader();
  reader.readAsDataURL(this.newImage);

  reader.onload = async (e: any) => {
    const dataUrl = e.target?.result as string;
    if (!dataUrl) return;

    const valid = await this.validateImageDimensions(dataUrl);
    if (!valid) {
      this.handleInvalidDimensions();
      return;
    }

    this.drop = true;
    this.previewSrc = dataUrl;
    this.url = dataUrl;
    this.changes = true;

    this.advancedForm.patchValue({ url: dataUrl });

    this.advancedForm.controls['urlPrefix'].disable();

  };
}




  dialogCancel(){
    const images = this.uploadService.getImagesUploaded();
    this.dialogRef.close([false]);
  }

  async dialogSave() {
    const invalidUrlPrefix = !this.isUrlPrefixValid;
    const needFile = !this.coverImage?.imageUrl && !this.selectedFile;

    if (this.advancedForm.invalid || invalidUrlPrefix || (this.alreadyPrefix && !this.isUpdate) || needFile) {
      const msgKey = needFile
        ? 'SnackBarConstants.COVER_IMAGE_NEEDED'
        : 'SnackBarConstants.MANDATORY_FIELDS_EMPTY';
      this.commentService.addSnackBar.emit(this.translateService.instant(msgKey));
      return;
    }

    this.commentService.progressSpin.emit(false);
    this.saving = true;
    this.advancedForm.controls['urlPrefix'].enable();

    try {
      let uploadedImage: { url: string; fileName: string; imageSize: [number, number] } | undefined;
      if (this.selectedFile) {
        uploadedImage = await this.uploadService.uploadCoverImage(
          this.selectedFile,
          this.advancedForm.value.urlPrefix,
          false
        );
      }

      const imageSize = uploadedImage?.imageSize;
      const fileName  = uploadedImage?.fileName;
      const imageUrl  = uploadedImage ? this.cacheBustedUrl(uploadedImage.url) : this.coverImage?.imageUrl ?? null;

      if (imageUrl) {
        this.advancedForm.patchValue({ url: imageUrl });
      }

      const translationsPayload: Record<string, { title: string; subtitle: string }> = {};
      this.translations.controls.forEach(ctrl => {
        const lang = ctrl.get('lang')?.value;
        const t = ctrl.get('title')?.value;
        const s = ctrl.get('subtitle')?.value;
        if (lang && t) translationsPayload[lang] = { title: t, subtitle: s || '' };
      });

      const { urlPrefix, defaultLanguage, title, subtitle, contextId, contentTypeId } = this.advancedForm.value;
      const payload: any = {
        urlPrefix,
        fileName,
        imageSize,
        imageUrl,
        defaultLanguage,
        title,
        subtitle: subtitle || undefined,
        contextId,
        contentTypeId,
        translations: Object.keys(translationsPayload).length ? translationsPayload : undefined
      };
      removeUndefinedValuesFromObject(payload);

      let result;
      if (this.isUpdate && this.existingId) {
        payload.id = this.existingId;
        const updateExperience = httpsCallable(this.functions, 'appStoreConnect-updateExperience');
        //console.log("update:", payload)
        result = await updateExperience(payload);
      } else {
        //console.log("create:", payload)
        const createExperience = httpsCallable(this.functions, 'appStoreConnect-createExperience');
        result = await createExperience(payload);
      }

      // await async refresh of prefixes
      await this.advancedService.getActualUrlPrefixes(false);

      const id = result.data?.id || this.existingId;
      const message = this.translateService.instant(this.isUpdate ? 'SnackBarConstants.UPDATE_OK' : 'SnackBarConstants.CREATE_OK');
      this.commentService.addSnackBar.emit(message);
      this.dialogRef.close([true, id, urlPrefix]);

    } catch (error) {
      console.log(error);
      const message = this.translateService.instant(this.isUpdate ? 'SnackBarConstants.UPDATE_FAILED' : 'SnackBarConstants.CREATE_FAILED');
      this.commentService.addSnackBar.emit(message);
      this.commentService.addSnackBar.emit(String(error));
    } finally {
      this.commentService.progressSpin.emit(false);
      this.saving = false;
    }
  }
}
